import React from "react"
import CP from "./AnimatedCirclePath"
import CircleProgress from "./styled/CircleProgress"
import ProgressStatus from "./styled/ProgressStatus"
import ETA from "./styled/ETA"
import ProgressUpload from "./styled/ProgressUpload"
import TimeLeftDisplay from "./TimeLeftDisplay"

const Progress = ({
  children,
  value,
  secondsRemaining,
  isFinished,
  ...rest
}) => {
  return (
    <CircleProgress as={CP} percentage={value} {...rest}>
      {value > 0 && !isFinished && (
        <ProgressUpload>
          <div>{Math.round(value * 100)}%</div>
          <ETA as={TimeLeftDisplay} seconds={secondsRemaining} />
        </ProgressUpload>
      )}
      {children && <ProgressStatus>{children}</ProgressStatus>}
    </CircleProgress>
  )
}

export default Progress
